export default __webpack_public_path__ + "static/media/redCross.e53fe7f3.svg";